import ToyotaBold from './Toyota-Bold.ttf';

const bold = {
  fontFamily: 'Toyota',
  src: `
    local('Toyota'),
    local('Toyota-Bold'),
    url(${ToyotaBold}) format('ttf')
  `,
};

export default bold;
